export class CanonicalizationError extends TypeError {
}
function serialize(value, seen) {
    if (value === null)
        return "null";
    if (typeof value === "string" || typeof value === "boolean")
        return JSON.stringify(value);
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            throw new CanonicalizationError("Action data must contain only finite numbers");
        return JSON.stringify(Object.is(value, -0) ? 0 : value);
    }
    if (Array.isArray(value)) {
        if (seen.has(value))
            throw new CanonicalizationError("Action data must not be cyclic");
        seen.add(value);
        const encoded = `[${value.map((entry) => serialize(entry, seen)).join(",")}]`;
        seen.delete(value);
        return encoded;
    }
    if (typeof value === "object") {
        const prototype = Object.getPrototypeOf(value);
        if (prototype !== Object.prototype && prototype !== null) {
            throw new CanonicalizationError("Action data must contain only plain JSON objects");
        }
        if (seen.has(value))
            throw new CanonicalizationError("Action data must not be cyclic");
        seen.add(value);
        const record = value;
        const encoded = `{${Object.keys(record)
            .sort()
            .map((key) => {
            const entry = record[key];
            if (entry === undefined)
                throw new CanonicalizationError("Action data must not contain undefined");
            return `${JSON.stringify(key)}:${serialize(entry, seen)}`;
        })
            .join(",")}}`;
        seen.delete(value);
        return encoded;
    }
    throw new CanonicalizationError(`Action data contains unsupported ${typeof value} value`);
}
/** Stable JSON shared by server hashing and browser verification. */
export function canonicalizeJson(value) {
    return serialize(value, new Set());
}
//# sourceMappingURL=canonical-json.js.map